module.exports = __webpack_public_path__ + "img/geofisica_9-16.a8dbcf10.jpg";